import { createBreakpoints } from "@chakra-ui/theme-tools";

export default createBreakpoints({
  xs: "375px",
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
  "2xl": "1400px",
  "3xl": "2560px",
});
